import { render, staticRenderFns } from "./img-block.vue?vue&type=template&id=4b989af3&scoped=true&"
import script from "./img-block.vue?vue&type=script&lang=ts&"
export * from "./img-block.vue?vue&type=script&lang=ts&"
import style0 from "./img-block.vue?vue&type=style&index=0&id=4b989af3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b989af3",
  null
  
)

export default component.exports